import React from "react";
import { useLanguage } from "../../../../context/LanguageContext";

const OrderNotesSection = ({ formData, setFormData, processing }) => {
  const { language } = useLanguage();

  // Check if payment method is selected before showing order notes
  const isPaymentMethodSelected = !!formData.paymentMethod;

  // Translations for order notes section
  const translations = {
    en: {
      orderNotes: "Order Notes",
      additionalInformation: "Additional information",
      notesPlaceholder:
        "Notes about your order, e.g. special delivery instructions",
      optional: "(Optional)",
    },
    ar: {
      orderNotes: "ملاحظات الطلب",
      additionalInformation: "معلومات إضافية",
      notesPlaceholder: "ملاحظات حول طلبك، مثل تعليمات التسليم الخاصة",
      optional: "(اختياري)",
    },
  };

  const t = translations[language] || translations.en;
  
  const handleNotesChange = (e) => {
    setFormData((prev) => ({ ...prev, orderNotes: e.target.value }));
  };

  // Don't render the section at all if payment method is not selected
  if (!isPaymentMethodSelected) {
    return null;
  }

  return (
    <div className="checkout-section">
      <h2>
        {t.orderNotes} <span className="optional-label">{t.optional}</span>
      </h2>

      <div className="form-group">
        <label htmlFor="order-notes">{t.additionalInformation}</label>
        <textarea
          id="order-notes"
          name="orderNotes"
          rows="4"
          value={formData.orderNotes}
          onChange={handleNotesChange}
          placeholder={t.notesPlaceholder}
          disabled={processing}
          dir={language === "ar" ? "rtl" : "ltr"}
        ></textarea>
      </div>
    </div>
  );
};

export default OrderNotesSection;
